import React, {useEffect, useState} from 'react'
import {useDrag, useDrop} from 'react-dnd'
import ToggleSwitch from '../../../components/toggleSwitch/ToggleSwitch'
import CustomButton, {DangerButton} from '../../../components/CustomButton'
import {useDispatch, useSelector} from 'react-redux'
import CustomIcon from '../../../components/CustomIcon'
import {TableCell} from '../../../components/table/CustomTable'
import ImageWrapper from '../../../components/table/ImageWrapper'
import { toggleBannerStatus } from 'redux/slices/bannerSlices'

const style = {
  cursor: 'move',
}

const BannerItem = ({
                      id,
                      moveCard,
                      findCard,
                      bannerItem,
                      screen,
                      tab,
                      onDelete,
                      onDraggedAndDropped,
                      onUpdateBanner,
                      onImageClicked
                    }) => {

  const [hoveredItem, setHoveredItem] = useState({})

  const originalIndex = findCard(id).index

  const [{isDragging}, drag] = useDrag({
    type: 'card',
    canDrag: bannerItem?.active_banner !== undefined,
    item: {id, originalIndex},
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const [, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      }
    },
    hover({id: draggedId}) {
      if (draggedId !== id) {
        const {index: hoverIndex, card} = findCard(id)
        setHoveredItem({index: hoverIndex, item: card})
      }
    },
    drop: (item, monitor) => {
      const {id: droppedId, originalIndex} = item
      if (
        originalIndex !== hoveredItem.index &&
        hoveredItem.item?.active_banner !== undefined
      ) {
        const {card: sourceItem} = findCard(droppedId)
        onDraggedAndDropped({sourceItem, targetIndex: hoveredItem.index})
        moveCard(droppedId, hoveredItem.index)
      } else {
        moveCard(droppedId, originalIndex)
      }
    },
  })

  const opacity = isDragging ? 0 : 1

  const dispatch = useDispatch()
  const [isOn, setIsOn] = useState(false)

  const {processing} = useSelector((state) => state.banner)

  useEffect(
    (e) => {
      setIsOn(bannerItem?.active_banner !== undefined)
    },
    [bannerItem?.active_banner],
  )

  const turnBannerOnAction = () => {
    setIsOn(!isOn)
    dispatch(
      toggleBannerStatus({
        payload: {banner_id: bannerItem.id, active: !isOn},
        screen: screen.value,
        tab: tab.value,
      }),
    )
  }
  return (
    <tr ref={(node) => drag(drop(node))} style={{...style, opacity}}>
      <TableCell isActive={bannerItem?.active_banner !== undefined}>
        <ImageWrapper imageUrl={bannerItem.image} onImageClicked={() => onImageClicked(bannerItem.image)}/>
      </TableCell>
      <TableCell isActive={bannerItem?.active_banner !== undefined}>
        <ImageWrapper imageUrl={bannerItem.image_for_web}
                      onImageClicked={() => onImageClicked(bannerItem.image_for_web)}/>

      </TableCell>
      <TableCell isActive={bannerItem?.active_banner !== undefined}>
        <div className="w-38">
          <a href={bannerItem.action_url} className="link" target="_blank">
            {bannerItem.action_url}
          </a>
        </div>
      </TableCell>
      <TableCell>
        <ToggleSwitch
          isChecked={isOn}
          isDisabled={processing}
          onChange={turnBannerOnAction}
        />
      </TableCell>

      <TableCell className="text-right">
        <div className="flex items-center justify-end space-x-2">
          <CustomButton
            onClick={onUpdateBanner} isIconButton={true}
          >
            <CustomIcon icon="edit"/>
          </CustomButton>
          <DangerButton
            onClick={onDelete} isIconButton={true}
          >
            <CustomIcon icon="delete"/>
          </DangerButton>
          <div className="flex items-center w-1 cursor-move" title="Drag">
            {bannerItem?.active_banner !== undefined && (
              <CustomIcon className="text-rand-200" icon="drag_indicator"/>
            )}
          </div>
        </div>
      </TableCell>
    </tr>
  )
}

export default BannerItem
